import {
  Alert,
  Button,
  CircularProgress,
  Divider,
  Typography,
  Box,
} from "@mui/material"
import React, { FC, useEffect } from "react"
import { useAppDispatch } from "@app/hooks"
import { useAuthMutation, setStandardAuth } from "@app/store"
import { PasswordElement, TextFieldElement } from "react-hook-form-mui"
import { Form } from "@core/components"
import { getUserRole } from "../../utils"
import { App } from "../../interfaces"
import { OIDCLoginButton } from "./oidc"

interface ILoginProps {}
interface IFormData {
  username: string
  password: string
}

export const Login: FC<ILoginProps> = (props) => {
  const dispatch = useAppDispatch()

  const [
    auth,
    {
      isLoading: isAuthLoading,
      isError: isAuthError,
      isSuccess: isAuthSuccess,
      error: authError,
    },
  ] = useAuthMutation()
  const submitForm = async (formData: IFormData) => {
    const res = await auth(formData).unwrap()
    const user: App.UserAuth = JSON.parse(atob(res.access_token.split(".")[1]))
    const role = getUserRole(user.role_name)
    dispatch(setStandardAuth({ token: res.access_token, role }))
  }

  const [errorMessage, setErrorMessage] = React.useState("")
  useEffect(() => {
    let text = ""
    if (!!authError && "status" in authError && authError.status === 401) {
      text = "Логин или пароль не верны"
    }
    setErrorMessage(text)
  }, [isAuthError])

  return (
    <>
      {isAuthError && (
        <Alert severity="error">Произошла ошибка! {errorMessage}</Alert>
      )}
      <Form<IFormData>
        onSubmit={submitForm}
        actions={[
          <Button
            type="submit"
            variant="contained"
            disabled={isAuthLoading}
            fullWidth
          >
            Войти&nbsp;{isAuthLoading && <CircularProgress size={20} />}
          </Button>,
        ]}
      >
        <TextFieldElement<IFormData>
          name="username"
          label="Логин"
          required={true}
        />
        <PasswordElement<IFormData>
          name="password"
          label="Пароль"
          required={true}
        />
      </Form>

      <Box mt={3}>
        <Divider>
          <Typography variant="body2" color="text.secondary">
            или
          </Typography>
        </Divider>
      </Box>

      <Box mt={3}>
        <OIDCLoginButton disabled={isAuthLoading} />
      </Box>
    </>
  )
}
